document.querySelectorAll('[data-testimonials-carousel]').forEach((root) => {
  const slides = root.querySelectorAll('[data-testimonial-slide]');
  const dots = root.querySelectorAll('[data-testimonial-dot]');
  if (slides.length < 2) return;

  const goTo = (index) => {
    const target = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === target));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === target));
  };

  const current = () => [...slides].findIndex((slide) => slide.classList.contains('is-active'));

  root.querySelector('[data-testimonial-prev]')?.addEventListener('click', () => goTo(current() - 1));
  root.querySelector('[data-testimonial-next]')?.addEventListener('click', () => goTo(current() + 1));
  dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.testimonialDot))));
});
